import { createFeature, createReducer, on } from '@ngrx/store';

import {
  getAutomaticFlowSchedulerEnabledStateSuccess,
  setAutomaticFlowEnabledStateSuccess,
  triggerAutomaticFlow,
  triggerAutomaticFlowError,
  triggerAutomaticFlowSuccess,
  triggerRecalculateBbaAdvice,
  triggerRecalculateBbaAdviceSuccess,
  triggerRecalculateBbaAdviceError,
  getAutomaticAdviceCustomersPreferencesLastUpdateSuccess,
} from './control-room.actions';

export interface ControlRoomState {
  enabledStates: { [key: string]: boolean };
  loading: { [key: string]: boolean };
  lastAutomaticAdviceCustomersPreferencesUpdate: Date | null;
}

export const initialState: ControlRoomState = {
  enabledStates: {},
  loading: {
    advice: false,
    exportFertilizationBalanceDataFertilab: false,
    order: false,
    bbaRecalculation: false,
  },
  lastAutomaticAdviceCustomersPreferencesUpdate: null,
};
export const controlRoomFeature = createFeature({
  name: 'automaticFlowScheduler',
  reducer: createReducer(
    initialState,
    on(getAutomaticFlowSchedulerEnabledStateSuccess, (state, { payload }) => ({
      ...state,
      enabledStates: {
        ...state.enabledStates,
        [payload.type]: payload.enabled,
      },
    })),
    on(triggerAutomaticFlow, (state, { payload: { type } }) => ({
      ...state,
      loading: {
        ...state.loading,
        [type]: true,
      },
    })),
    on(triggerAutomaticFlowSuccess, (state, { payload: { type } }) => ({
      ...state,
      loading: {
        ...state.loading,
        [type]: false,
      },
    })),
    on(triggerAutomaticFlowError, (state, { payload: { type } }) => ({
      ...state,
      loading: {
        ...state.loading,
        [type]: false,
      },
    })),
    on(setAutomaticFlowEnabledStateSuccess, (state, { payload }) => ({
      ...state,
      enabledStates: {
        ...state.enabledStates,
        [payload.type]: payload.enabled,
      },
    })),
    on(triggerRecalculateBbaAdvice, (state) => ({
      ...state,
      loading: {
        ...state.loading,
        bbaRecalculation: true,
      },
    })),
    on(triggerRecalculateBbaAdviceSuccess, (state) => ({
      ...state,
      loading: {
        ...state.loading,
        bbaRecalculation: false,
      },
    })),
    on(triggerRecalculateBbaAdviceError, (state) => ({
      ...state,
      loading: {
        ...state.loading,
        bbaRecalculation: false,
      },
    })),
    on(getAutomaticAdviceCustomersPreferencesLastUpdateSuccess, (state, { payload }) => ({
      ...state,
      lastAutomaticAdviceCustomersPreferencesUpdate: payload.lastUpsertion ? new Date(payload.lastUpsertion) : null,
    })),
  ),
});

export const { selectEnabledStates, selectLoading } = controlRoomFeature;
